let baseUrl = "";

if (process.env.NODE_ENV === "development") {
  // 开发
  baseUrl = "https://buildapi.jamespang.cn";
} else {
  // 生产环境
  baseUrl = "https://buildapi.jamespang.cn";
}

export default baseUrl;
